import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, FormWrapper } from "./CreateAdvertisersStyles";
//import { FaEye, FaEyeSlash } from "react-icons/fa";
import BackButton from "../../../components/common/BackButton";

import { createAdvertiser } from "../../../redux/slices/advertiserSlice";

const CreateAdvertisers = ({ loading }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    //password: "",
    skype: "",
    phoneNumber: "",
    companyName: "",
    location: "",
  });
  //const [showPassword, setShowPassword] = useState(false);
  // const toggleType = () => {
  //   setShowPassword(!showPassword);
  // };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // dispatch(createAdvertiser(formData))
    try {
      const result = await dispatch(createAdvertiser(formData)).unwrap();
      if (result.statusCode === 201) { // Assuming `statusCode` indicates success
        navigate("/advertisers");
      } else {
        // Handle API errors if needed
        console.error("Failed to create advertiser:", result.message);
      }
    } catch (error) {
      console.error("Error creating advertiser:", error);
    }
    
  };

  return (
    <>
    <BackButton></BackButton>
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Create Advertiser</h3>
          <p>
            Set up an advertiser profile to get them started with campaigns and
            tracking.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormWrapper className="grid-row-3">
          <div className="field-group">
            <label htmlFor="firstName">First name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label htmlFor="lastName">Last name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </FormWrapper>

        <FormWrapper className="grid-row-3">
          <div className="field-group">
            <label htmlFor="phoneNumber">Phone number</label>
            <input
              type="number"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Phone number"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label htmlFor="skype">Skype ID</label>
            <input
              type="text"
              id="skype"
              name="skype"
              placeholder="Skype ID"
              value={formData.skype}
              onChange={handleChange}
            />
          </div>
          <div className="field-group">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
              required
            />
          </div>
        </FormWrapper>

        <FormWrapper className="full-width">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        {/* <FormWrapper>
          <label htmlFor="currentPassword">Current Password</label>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Current password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          {showPassword ? (
            <FaEyeSlash className="eye" onClick={toggleType} />
          ) : (
            <FaEye className="eye" onClick={toggleType} />
          )}
        </FormWrapper> */}

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create"}
            </button>
          </div>
        </div>
      </form>
    </Container>
    </>
  );
};

export default CreateAdvertisers;
